import React, {useMemo} from "react"
import {SchoolClass, SchoolClassCheckIn} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import moment from "shared/moment"
import MoodAverage from "components/score-factor-groups/mood-average"
import MoodSimpleLineChart from "components/score-factor-groups/mood-simple-line-chart"
import PageContentsPresentation from "components/page-contents/presentation"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

/**
 * @typedef {object} Slide2Props
 * @property {unknown} refreshVersion
 * @property {unknown} schoolClass
 * @property {unknown} schoolClassCheckIn
 */

/**
 * @typedef {object} Slide2State
 * @property {unknown} latestCheckIn
 * @property {unknown} latestSchoolClassCheckInQuery
 */

/**
 * @extends {ShapeComponent<Slide2Props, Slide2State>}
 */
class Slide2 extends ShapeComponent {
  /** @type {Slide2State} */
  state = {
    latestCheckIn: undefined,
    latestSchoolClassCheckInQuery: undefined
  }

  static propTypes = propTypesExact({
    refreshVersion: PropTypes.string.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired,
    schoolClassCheckIn: PropTypes.instanceOf(SchoolClassCheckIn).isRequired
  })

  setup() {
    const {schoolClass} = this.p
    const {t} = useI18n({namespace: "js.routes.user.school_classes.school_class_check_ins.slide_2"})

    this.dateFrom = useMemo(() => moment().subtract(4, "weeks").startOf("day").toDate(), [])
    this.dateTo = useMemo(() => new Date(), [])
    this.t = t


    useMemo(() => {
      if (schoolClass) {
        this.loadLastSchoolClassCheckIn()
      }
    }, [schoolClass?.id(), this.p.refreshVersion])
  }

  async loadLastSchoolClassCheckIn() {
    const {schoolClass} = this.p
    const latestCheckIn = await SchoolClassCheckIn
      .ransack({
        s: "created_at DESC",
        school_class_id_eq: schoolClass.id(),
        state_eq: "closed"
      })
      .select({SchoolClassCheckIn: ["createdAt", "id"]})
      .first()

    this.setState({
      latestCheckIn,
      latestSchoolClassCheckInQuery: SchoolClassCheckIn.ransack({id_eq: latestCheckIn?.id() || "no-latest-check-in-fake-uuid"})
    })
  }

  render() {
    const {dateFrom, dateTo} = this.tt
    const {schoolClass, schoolClassCheckIn} = this.p
    const {latestCheckIn, latestSchoolClassCheckInQuery} = this.s
    const moodCircleActive = latestCheckIn?.length > 0

    return (
      <View dataSet={{component: "routes--user--school-classes--school-class-check-ins--slide-2"}}>
        <PageContentsPresentation
          identifier="user/school-classes/school-class-check-ins/slide-2"
          liquidVariables={{schoolClass, schoolClassCheckIn}}
        />
        <View style={{flexDirection: "row", width: "100%"}}>
          <View style={{width: 600}}>
            {latestSchoolClassCheckInQuery &&
              <MoodAverage
                className="latest-woofs-mood-average"
                defaultAverage={moodCircleActive ? undefined : 3.0}
                refreshVersion={this.p.refreshVersion}
                schoolClassCheckInsQuery={latestSchoolClassCheckInQuery}
              />
            }
          </View>
          <View style={{flexGrow: 1, paddingLeft: 30}}>
            <MoodSimpleLineChart dateFrom={dateFrom} dateTo={dateTo} refreshVersion={this.p.refreshVersion} schoolClass={schoolClass} />
          </View>
        </View>
      </View>
    )
  }
}

export default memo(shapeComponent(Slide2))
